import { render } from "./GridGolonganObat.vue?vue&type=template&id=746beed4"
import script from "./GridGolonganObat.vue?vue&type=script&lang=js"
export * from "./GridGolonganObat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__